import { render, staticRenderFns } from "./NavBarTournamentButtonMobile.vue?vue&type=template&id=612032b4&scoped=true&"
import script from "./NavBarTournamentButtonMobile.vue?vue&type=script&lang=js&"
export * from "./NavBarTournamentButtonMobile.vue?vue&type=script&lang=js&"
import style0 from "./NavBarTournamentButtonMobile.vue?vue&type=style&index=0&id=612032b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612032b4",
  null
  
)

export default component.exports